// removed by extract-text-webpack-plugin
module.exports = {"new-template-input-row":"emailTemplatesCreation__new-template-input-row___231yw","new-template-panel-content":"emailTemplatesCreation__new-template-panel-content___2EbHx","new-template-folder-information":"emailTemplatesCreation__new-template-folder-information___3q5Rt","new-template-import-icon":"emailTemplatesCreation__new-template-import-icon___1xlTQ","create-template-red-color":"emailTemplatesCreation__create-template-red-color___2IrXz"};


//////////////////
// WEBPACK FOOTER
// ./src/views/email/emailTemplatesCreation/emailTemplatesCreation.less
// module id = 300
// module chunks = 3